import { ReactNode, SyntheticEvent } from "react";
import { dynamicTextColor } from "view/statuses/utils/StatusUtils";
import { Chip, darken, SxProps, Theme } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import OverflowTooltip from "components/cck/OverflowTooltip";

type StatusChipProps = {
	label: ReactNode;
	color: string | null | undefined;
	disabled?: boolean;
	onClick?: (event: SyntheticEvent) => void;
	onHistoryClick?: () => void;
	sx?: SxProps<Theme>;
}

const StatusChip = ({ label, color, onClick, onHistoryClick, disabled, sx }: StatusChipProps) => {

	color = color ?? "#333333";

	const showHistory = !!onHistoryClick;

	const handleOnClick = (event: SyntheticEvent) => {
		if (!disabled && onClick) {
			onClick(event);
		}
	};

	const textColor = dynamicTextColor(color);

	return (
		<Chip
			size="small"
			sx={{
				width: 150,
				backgroundColor: color,
				color: textColor,
				gap: 1,
				borderRadius: "4px",
				":hover": {
					backgroundColor: darken(color, 0.1),
				},
				".MuiChip-label": {
					flexGrow: 1,
					fontSize: "12px",
					fontWeight: "bold",
					textAlign: "center",
				},
				":has(.MuiChip-deleteIcon) .MuiChip-label": {
					paddingLeft: 1.5,
					paddingRight: "unset",
				},
				".MuiChip-deleteIcon": {
					fontSize: "18px",
				},
				"&.Mui-disabled": {
					opacity: 1,
					cursor: "not-allowed",
					pointerEvents: "unset",
					":hover": {
						backgroundColor: color,
					},
				},
				...sx,
			}}

			label={<OverflowTooltip title={label} enterDelay={500}>{label}</OverflowTooltip>}
			disabled={disabled || !onClick}
			onClick={!disabled && !!onClick ? handleOnClick : undefined}
			deleteIcon={showHistory ? (
				<HistoryIcon
					sx={{
						color: textColor + " !important",
						":hover": {
							color: darken(textColor ?? "#333", 0.1) + " !important",
						},
					}}
				/>
			) : undefined}
			onDelete={onHistoryClick}
		/>
	);
};

export default StatusChip;
